/**
 *
 * TransformEffect
 *
 * @export
 * @class TransformEffect
 * @extends {PIXI.Container}
*/
export default class TransformEffect extends PIXI.Container {
	/**
     * Creates an instance of TransformEffect.
	 */
	constructor() {
		super();

		this.visible = false;
		this.tl = null;

		this.bg = null;
		this.ray0 = null;
		this.ray1 = null;
		this.ray2 = null;

		// this.blendMode = PIXI.BLEND_MODES.ADD;
		this.blendMode = PIXI.BLEND_MODES.NORMAL;

		this.create();
	}

	/**
     *
     * create
     *
	 */
	create() {
		// bg
		this.bg = new PIXI.Sprite(P3.assets.texture('transform_001'));
		this.bg.anchor.set(0.5);
		this.bg.blendMode = this.blendMode;
		this.addChild(this.bg);

		// ray 0
		this.ray0 = new PIXI.Sprite(P3.assets.texture('transform_002'));

		this.ray0.scale.set(0.9);
		this.ray0.anchor.set(0.5);
		this.ray0.alpha = 0.5;
		this.ray0.blendMode = this.blendMode;

		this.addChild(this.ray0);

		// ray 1
		this.ray1 = new PIXI.Sprite(P3.assets.texture('transform_003'));
		this.ray1.scale.set(1.1);
		this.ray1.anchor.set(0.5);
		this.ray1.alpha = 0.5;
		this.ray1.blendMode = this.blendMode;

		this.addChild(this.ray1);

		// ray 2
		this.ray2 = new PIXI.Sprite(P3.assets.texture('transform_004'));
		this.ray2.scale.set(0.8);
		this.ray2.anchor.set(0.5);
		this.ray2.alpha = 0;
		this.ray2.blendMode = this.blendMode;

		this.addChild(this.ray2);
	}

	/**
     *
     * getBenPosition
     *
	 */
	getBenPosition() {
		const benPosition = this.parent.benScreenPosition();

		this.x = benPosition.x;
		this.y = benPosition.y;
	}

	/**
     *
     * show
     *
     * @param {number} [delay=0.5]
     * @param {boolean} [isFull=true]
	 */
	show(delay = 0.5, isFull = true) {
		this.killTL();

		this.tl = new TimelineMax({

			delay: delay,

			onStart: () => {
				this.getBenPosition();

				this.scale.set(0);

				this.visible = true;
			},

			onUpdate: () => {
				if (isFull) {
					return;
				}

				this.getBenPosition();
			},

			onComplete: () => {
				this.scale.set(1);
				this.ray0.rotation = 0;
				this.ray1.rotation = 0;
				this.ray2.rotation = 0;
				this.ray2.alpha = 0;

				this.visible = false;
			}
		});

		const duration = 0.4;
		const maxScale = 6;

		this.tl.to(this.scale, duration,
			{
				x      : maxScale,
				y      : maxScale,
				repeat : 1,
				yoyo   : true,
				ease   : Back.easeOut
			}, 'start');

		this.tl.to(this.ray0, duration,
			{
				rotation : (Math.PI / 2) + (Math.random() * 0.2) - 0.1,
				repeat   : 1,
				yoyo     : true,
				ease     : Cubic.easeOut
			}, 'start');

		this.tl.to(this.ray1, duration,
			{
				rotation : -(Math.PI / 2) + (Math.random() * 0.2) - 0.1,
				repeat   : 1,
				yoyo     : true,
				ease     : Cubic.easeIn
			}, 'start');

		this.tl.to(this.ray2, duration,
			{
				rotation : (Math.PI / 2) + (Math.random() * 0.2) - 0.1,
				alpha    : 1,
				repeat   : 1,
				yoyo     : true,
				ease     : Back.easeInOut
			}, 'start');

		if (!isFull) {
			TweenMax.delayedCall(delay, () => {
				this.tl.time(duration / 2);
			});
		}
	}

	pause() {
		if (this.tl) {
			this.tl.pause();
		}
	}

	play() {
		if (this.tl) {
			this.tl.play();
		}
	}

	killTL() {
		if (this.tl) {
			this.tl.kill();
		}
	}

	/**
     *
     * doSeppuku
     *
	 */
	destroy() {
		this.killTL();

		this.ray0.destroy({children: true});
		this.ray1.destroy({children: true});
		this.ray2.destroy({children: true});

		super.destroy({children: true});
	}
}
